@if (availableApps.length === 0) {
  <div>
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  </div>
}

@if (availableApps.length > 0) {
  <div class="defaultPageInstructions"
    [style.display]="this.lmContextService.inMingleWidget() ? 'none' : 'block'"
    >
    <label>{{instructions}}</label>
  </div>
}

@if (hideTitleBar) {
  <lm-toolbar
    [inHeader]="false"
    [sectionTitle]="sectionTitle"
    [buttons]="toolbarButtons | async"
    (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
  ></lm-toolbar>
}

<div class="row">
  <div class="twelve columns">
    @if (availableApps) {
      <div class="row blockgrid">
        @for (app of availableApps; track app) {
          <div class="block">
            <lm-simple-card
              [automationId]="app.webAppName"
              [style.border-style]="this.lmContextService.inMingleWidget() ? 'none' : 'solid'"
              [style.marginBottom]="this.lmContextService.inMingleWidget() ? '-15px' : '20px'"
              [type]="'webapp'"
              [imageUrl]="app.webAppIconUrl || './specicon/frameworkGenericStar'"
              [title]="app.webAppTitle || app.webAppName"
              [description]="app.webAppDescription"
              [paragraphLayout]="false"
              [link]="app.webAppUrl"
              [preferred]="isPreferredWebApp(app)"
              [webAppName]="app.webAppName"
              [fromHomeSuite]="true"
              [noAccess]="noAccess"
              (anchorClicked)="onAnchorClicked($event)"
              (preferredMenuEvent)="onPreferredMenuEvent($event)"
            ></lm-simple-card>
          </div>
        }
      </div>
    }
  </div>
</div>
